function initAutocomplete() {
    for (const input of document.getElementsByClassName("places-autocomplete-input")) {
        if (!input) continue;

        const autocomplete = new google.maps.places.Autocomplete(input, {
            types: ['address'], // restrict results to addresses only
            componentRestrictions: { country: input.dataset['country'] }
            // componentRestrictions: { country: 'us' }, // optional, limit results by country
        });

        autocomplete.addListener('place_changed', () => {
            const place = autocomplete.getPlace();
            input.dispatchEvent(new CustomEvent('place_changed', {detail: place}));
            console.log(place);
            // You can now extract details like place.formatted_address, place.geometry.location, etc.
        });
    }
}

function loadGoogleMaps() {
    return new Promise((resolve, reject) => {
        if (window.google) return resolve(window.google);

        const script = document.createElement("script");
        script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAtMAEI4gggogbj3qRMXlKM7D1B-djc49M&libraries=places";
        script.async = true;
        script.onload = () => resolve(window.google);
        script.onerror = reject;
        document.head.appendChild(script);
    });
}

loadGoogleMaps().then(() => {
    initAutocomplete(); // call manually
});